<template>
  <div class="nylon-Hero" :class="tag.slug">
    <div class="nylon-Hero-liner">
      <div class="nylon-Hero-text">
        <h2><span class="hash">#</span>{{ tag.name }}</h2>
        <h3>{{ tag.desc }}</h3>
      </div>
    </div>
  </div>
  <div class="nylon-Content u-cf">
    <div class="u-bumper u-textCenter">
      <div class="nylon-Text">
        <h1 class="nylon-Text-headline--h1"></h1>
      </div>
    </div>
    <div class="nylon-Gallery nylon-Gallery--center">
      <InertiaLink
        v-for="product in products"
        :key="product.id"
        class="nylon-Gallery-item nylon-MiniProduct"
        :class="{
          'nylon-MiniProduct--success': isClosedCampaign(product) && product.success,
          'nylon-MiniProduct--fail': isClosedCampaign(product) && !product.success,
        }"
        :href="product.url"
      >
        <div class="nylon-MiniProduct-wrapper">
          <div class="nylon-MiniProduct-image">
            <product-image-v2 class="nylon-MiniProduct-imageFile" :product-id="product.id" :default="true" :hash="product.imageCacheHash" :alt="product.title" sizes="(min-width: 640px) 300px, 44vw" />
            <div class="nylon-MiniProduct-imageIcon">
              <NylonIcon icon-name="uiArrow--Right" />
            </div>
          </div>
          <div class="nylon-MiniProduct-meta">
            <div class="nylon-MiniProduct-title">
              {{ product.title }}
              <div v-if="product.salesMethod === 'campaign' && product.preorderStatus === 'live'" class="nylon-Tags">
                <span v-if="product.isNew" class="nylon-Tags-tag nylon-Tags-tag--new" data-tooltip="New">
                  <NylonIcon icon-name="Icon-tagNew" view-box="0 0 20 20" />
                </span>
                <span v-if="product.isClose" class="nylon-Tags-tag nylon-Tags-tag--almost" data-tooltip="Almost">
                  <NylonIcon icon-name="Icon-tagAlmost" view-box="0 0 20 20" />
                </span>
                <span v-if="product.isGoingToPrint" class="nylon-Tags-tag nylon-Tags-tag--print" data-tooltip="Print It">
                  <NylonIcon icon-name="Icon-tagPrint" view-box="0 0 20 20" />
                </span>
                <span v-if="product.isEndingSoon" class="nylon-Tags-tag nylon-Tags-tag--ending" data-tooltip="Ending">
                  <NylonIcon icon-name="Icon-tagEnding" view-box="0 0 20 20" />
                </span>
              </div>
            </div>
            <div class="nylon-MiniProduct-designerWrapper">
              by <span class="nylon-MiniProduct-designer">{{ product.designerName }}</span>
            </div>
            <template v-if="product.salesMethod === 'campaign'">
              <div v-if="product.preorderStatus === 'live'" class="nylon-MiniProduct-details">
                <template v-if="product.salesVisible">
                  <span class="nylon-MiniProduct-sold">{{ product.sold }} sold</span> /
                </template>
                <span class="nylon-MiniProduct-days">{{ product.timeLeft }} left</span>
              </div>
              <div v-else-if="product.preorderStatus === 'expired'" class="nylon-MiniProduct-details">
                <template v-if="product.salesVisible">
                  <span class="nylon-MiniProduct-sold">{{ product.lifetimeSold }} sold</span> /
                  <span class="nylon-MiniProduct-requested">{{ product.requests }} requested</span>
                </template>
              </div>
            </template>
          </div>
        </div>
      </InertiaLink>
    </div>
  </div>
</template>

<script>
import { Link as InertiaLink } from "@inertiajs/vue3";
import StorefrontLayout from "@/layout/storefront-layout.vue";

import ProductImageV2 from "@/product/components/product-image-v2.vue";
export default {
  name: "ProductsTagged",
  layout: StorefrontLayout,
  components: { InertiaLink, ProductImageV2 },

  props: {
    tag: { type: Object, required: true },
    products: { type: Array, default: () => [] },
  },

  methods: {
    isClosedCampaign(product) {
      return product.salesMethod === "campaign" && product.preorderStatus === "expired";
    },
  },
};
</script>
